import { FC } from "react";
import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ApiError } from "../types";

interface Props {
  error?: unknown;
}

const ErrorScreen: FC<Props> = ({ error }) => {
  const { t } = useTranslation(["contract-updates"]);
  const message =
    (error as ApiError)?.response?.data?.message ??
    t(
      "contract-updates:error-fetch-failed",
      "We couldn't load this contract update. Please try opening the link from the original email again.",
    );

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="mb-4 flex size-16 items-center justify-center rounded-full bg-red-100">
        <AlertCircle className="size-8 text-red-600" />
      </div>
      <h1 className="text-xl font-bold mb-2">
        {t("contract-updates:error-title", "Something went wrong")}
      </h1>
      <p className="text-muted-foreground max-w-md">{message}</p>
    </div>
  );
};

export default ErrorScreen;
